export const makeMapping = {
  'alfa romeo': 'Alfa Romeo',
  bmw: 'BMW',
  ds: 'DS',
  'mercedes-benz': 'Mercedes-Benz',
  mini: 'MINI',
  'rolls-royce': 'Rolls Royce',
  tvr: 'TVR',
  'mg motor uk': 'MG Motor UK'
};

export const formatMake = make => {
  if (!make) {
    return;
  }

  let formattedMake = makeMapping[make.toLowerCase()]
    ? makeMapping[make.toLowerCase()]
    : make;

  return formattedMake;
};



// WEBPACK FOOTER //
// ./src/utils/make/index.js